@import "src/globals/common.scss";

.modal-container {
  position: absolute;
  top: 0;
  left: 0;
  padding: 6px;
  height: 100%;
  width: 100%;

  &__content {
    z-index: 2;
    position: relative;
    padding: 2%;
    border-radius: $borderRadius;
    background-color: $primaryBackgroundColor;
    text-align: center;
    max-width: 80%;
    left: 8%;
    margin-top: 10%;
  }

  &__message {
    padding: 25px;
  }

  &__wrapper {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: #555;
    opacity: 0.9;
    z-index: 1;
    border-radius: $borderRadius;
  }
}
